/**
 * PUT a body to an S3 (or other) presigned URL.
 * Capacitor Android uses server.hostname = test/prod admin host so WebView Origin
 * matches ziniz.online (API allowlist + S3 CORS). Do not enable CapacitorHttp —
 * it strips Origin/Referer and login returns Forbidden.
 *
 * @param {string} presignedUrl
 * @param {Blob|File|string|ArrayBuffer} body
 * @param {string} [contentType]
 * @returns {Promise<Response>}
 */
export async function putPresignedObject(presignedUrl, body, contentType) {
  if (!presignedUrl || typeof presignedUrl !== "string") {
    throw new Error("Missing upload URL");
  }
  const headers = {};
  if (contentType) headers["Content-Type"] = contentType;

  let res;
  try {
    res = await fetch(presignedUrl, {
      method: "PUT",
      body,
      headers,
    });
  } catch (err) {
    const msg = err?.message || String(err);
    if (/failed to fetch|networkerror|load failed/i.test(msg)) {
      throw new Error(
        "Could not reach storage (network/CORS). Rebuild the Android app with server.hostname set to the test/prod admin host."
      );
    }
    throw err;
  }
  if (!res.ok) {
    throw new Error(`Upload failed: ${res.status}`);
  }
  return res;
}
